import { create } from 'zustand';

const useSubscriptionPackageLogStore = create((set) => ({
  // Filters & Selection
  sortingData: false,
  setSortingData: (sort) => set({ sortingData: sort }),

  validData: false,
  setValidData: (valid) => set({ validData: valid }),

  schedularDate: {},
  setSchedularDate: (date) => set({ schedularDate: date }),

  selectedStatus: 'ALL',
  setSelectedStatus: (status) => set({ selectedStatus: status }),

  upDateSelectedStatus: [],
  setUpDateSelectedStatus: (statusArray) => set({ upDateSelectedStatus: statusArray }),
  
  searchTerm: '',
  setSearchTerm: (term) => set({searchTerm : term}),

  useEffectCall: false,
  setUseEffectCall: (call) => set({useEffectCall : call}),

  homeDeliveryValue: false,
  setHomeDeliveryValue: (call) => set({homeDeliveryValue : call}),
  urgentDeliveryValue: false,
  setUrgentDeliveryValue: (call) => set({urgentDeliveryValue : call}),

  // Order Data
  // customerALLOrdersData: [],
  // setCustomerALLOrdersData: (orders) => set({ customerALLOrdersData: orders }),

  customerALLOrdersData: [],
  setCustomerALLOrdersData: (updater) =>
    set((state) => ({
      customerALLOrdersData:
        typeof updater === 'function' ? updater(state.customerALLOrdersData) : updater,
    })),

  statusTotalData: [],
  setStatusTotalData: (data) => set({ statusTotalData: data }),

  sumOfGrandTotal: 0,
  setSumOfGrandTotal: (total) => set({ sumOfGrandTotal: total }),

  sumOfOrderCount: 0,
  setSumOfOrderCount: (count) => set({ sumOfOrderCount: count }),

  // Pagination
  page: 0,
  // setPage: (newPage) => set({ page: newPage }),
  setPage: (updater) =>
    set((state) => ({
      page:
        typeof updater === 'function' ? updater(state.page) : updater,
    })),
}));

export default useSubscriptionPackageLogStore;
